/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var PwaInstallHandler = /** @class */ (function () {
    function PwaInstallHandler() {
        var _this = this;
        this.event = null;
        this.callbacks = [];
        /**
         * Triggers install prompt.
         */
        this.install = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.event) return [3 /*break*/, 2];
                        this.event.prompt();
                        return [4 /*yield*/, this.event.userChoice.then(function (_a) {
                                var outcome = _a.outcome;
                                _this.updateEvent(null);
                                return outcome === 'accepted';
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: throw new Error('Not allowed to prompt.');
                }
            });
        }); };
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('beforeinstallprompt', function (event) {
            event.preventDefault();
            _this.updateEvent(event);
        });
        window.addEventListener('appinstalled', function () {
            _this.updateEvent(null);
        });
    }
    /**
     * Returns internal `BeforeInstallPromptEvent`.
     */
    PwaInstallHandler.prototype.getEvent = function () {
        return this.event;
    };
    /**
     * Tells whether the app is ready to be installed.
     */
    PwaInstallHandler.prototype.canInstall = function () {
        return this.event !== null;
    };
    PwaInstallHandler.prototype.updateEvent = function (event) {
        var _this = this;
        if (event === this.event) {
            return;
        }
        this.event = event;
        this.callbacks.forEach(function (callback) { return callback(_this.canInstall()); });
    };
    /**
     * Adds listener with a callback which is called when installability state changes.
     */
    PwaInstallHandler.prototype.addListener = function (callback) {
        callback(this.canInstall());
        this.callbacks.push(callback);
    };
    /**
     * Removes listener.
     */
    PwaInstallHandler.prototype.removeListener = function (callback) {
        this.callbacks = this.callbacks.filter(function (otherCallback) { return callback !== otherCallback; });
    };
    return PwaInstallHandler;
}());
var pwaInstallHandler = new PwaInstallHandler();

export { pwaInstallHandler };
//# sourceMappingURL=index.es.js.map
